import React, { useState } from "react";
import { SignupScreen } from "./SignupScreen";
import { useAuth } from '../contexts/AuthContext'; // 👈 Import the hook
import { getApiBaseUrl } from "../api/utils";
import "./LoginModal.css";

const API_URL = getApiBaseUrl();

const LoginModal = ({ defaultValue = "", onClose, onSuccess }) => {
  const [mode, setMode] = useState("login");
  const [identifier, setIdentifier] = useState(defaultValue);
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const { login } = useAuth();

  const handleLogin = async () => {
    setError(""); // Clear previous errors
    try {
      const body = new URLSearchParams();
      body.set("username", identifier.trim());
      body.set("password", password);

      const response = await fetch(`${API_URL}/users/login/`, {
        method: "POST",
        headers: {
          accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: body.toString(),
      });

      if (!response.ok) throw new Error("Login failed");
      const data = await response.json();
      if (!data?.access_token) throw new Error("Login failed");
      await login(data.access_token);
      onSuccess(data.access_token);
    } catch (err) {
      setError("Invalid credentials. Try again or sign up.");
    }
  };

  const handleSignupSuccess = (token) => {
    if (token) {
      onSuccess(token);
      return;
    }
    onSuccess(token);
  };

  return (
    <div className="auth-modal-overlay">
      <div className="auth-modal-container">
        {/* Close button is now universally here for both modes */}
        <button className="auth-modal-close-btn" onClick={onClose}>
           &times;
        </button>

        {mode === "login" ? (
          <>
            <h2 className="auth-modal-title">Login</h2>
            <p className="auth-modal-subtitle">
              Use the email or phone number you signed up with.
            </p>
            
            <label className="auth-modal-form-group">
                <span className="auth-modal-label">Email or phone</span>
                <input
                type="text"
                placeholder="you@example.com"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                className="auth-modal-input"
                />
            </label>

            <label className="auth-modal-form-group">
                <span className="auth-modal-label">Password</span>
                <input
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="auth-modal-input"
                />
            </label>

            {error && <p className="auth-modal-error-msg">{error}</p>}

            <button className="auth-modal-submit-btn" onClick={handleLogin}>
              Log In
            </button>

            <p className="auth-modal-toggle-link" onClick={() => setMode("signup")}>
              Don’t have an account? <span>Create one</span>
            </p>
          </>
        ) : (
          <SignupScreen
            defaultValue={defaultValue}
            onNavigateToLogin={() => setMode("login")}
            onSuccess={handleSignupSuccess}
          />
        )}
      </div>
    </div>
  );
};

export default LoginModal;
